import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Icon } from '@fiverr-private/fit';
import { l_chevron_down } from '@fiverr-private/icons';

import './style.scss';

const { POSITIONS } = Popover;

const PopoverItems = ({ target, children }) => (
    <Popover
        className="nav-popover"
        contentClassName="nav-popover-content"
        containerClassName="nav-popover-container"
        boxClassName="nav-popover-box"
        boxContentClassName="nav-popover-box-content"
        openClassName="nav-popover-open"
        position={POSITIONS.BOTTOM}
        appendToBody={false}
        content={<ul className="drop-shadow-z2">{children}</ul>}
    >
        <>
            {target}
            <Icon size={10} className="popover-content-icon">
                {l_chevron_down}
            </Icon>
        </>
    </Popover>
);

PopoverItems.propTypes = {
    target: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default PopoverItems;
